import * as React from 'react';

function SvgSpaceBar(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M18 13H6V9H4v6h16V9h-2z' />
		</svg>
	);
}

export default SvgSpaceBar;
